import client from "../services/api"


export const listPanelMessages = (page: number = 1, per_page?: number) => {
    return client.get('/panel-messages', {params: {page, per_page}})
}

export const showPanelMessage = (panelMessage: Pick<PanelMessage, 'id'>) => {
    return client.get(`/panel-messages`, {params: {id: panelMessage.id}})
}

export const createPanelMessage = (panelMessage: PanelMessage) => {
    return client.post(`/panel-messages`, panelMessage)
}

export const updatePanelMessage = (panelMessage: Pick<PanelMessage, 'id'>) => {
    return client.patch(`/panel-messages/${panelMessage.id}`, panelMessage)
}

export const deletePanelMessage = (panelMessage: Pick<PanelMessage, 'id'>) => {
    return client.delete(`/panel-messages/${panelMessage.id}`)
}

export const clientPanelMessage = () => {
    return client.get(`/clients/panel-messages`)
}